import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { OssVatRateOrderingCommand, OssVatRateOrderingCommandHandlerBase, OssVatRateOrderingResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(OssVatRateOrderingCommand)
@Injectable({ providedIn: 'root'})
export class OssVatRateOrderingCommandHandler {
    private commandHandler: OssVatRateOrderingCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new OssVatRateOrderingCommandHandlerBase(http);
    }

    public async handleAsync(cmd: OssVatRateOrderingCommand): Promise<OssVatRateOrderingResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
